import { Button, Typography } from '@mui/material';

import { BrowserDetectorIcon } from '@/components/BrowserDetector/BrowserDetector.styled';
import { ActionBar } from '@/components/Layout';

import { useTranslate } from '@/hooks/useTranslate';

import { getDataTestId } from '@/utils/browser';

import { BottomFixedPaper, PreQuestionsContainer } from './components.styled';

type UnemployedConfirmationProps = Readonly<{
  onConfirm: () => void;
  onCancel: () => void;
}>;

export function UnemployedConfirmation({
  onConfirm,
  onCancel,
}: UnemployedConfirmationProps) {
  const { t } = useTranslate();
  return (
    <BottomFixedPaper elevation={2}>
      <PreQuestionsContainer>
        <BrowserDetectorIcon />
        <Typography variant="h4" textAlign="center">
          {t('moreInfo.employmentInfoDrawer.unemployedConfirmation.title')}
        </Typography>
        <Typography variant="body2" textAlign="center" mt={1}>
          {t(
            'moreInfo.employmentInfoDrawer.unemployedConfirmation.description',
          )}
        </Typography>
        <ActionBar mt={3}>
          <Button
            {...getDataTestId(`basic-info-no-button`)}
            variant="outlined"
            fullWidth
            onClick={onCancel}
          >
            {t('common.cancel')}
          </Button>
        </ActionBar>
        <ActionBar mt={3}>
          <Button
            {...getDataTestId(`basic-info-yes-button`)}
            variant="contained"
            fullWidth
            onClick={onConfirm}
          >
            {t('common.confirm')}
          </Button>
        </ActionBar>
      </PreQuestionsContainer>
    </BottomFixedPaper>
  );
}
